import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateSchoolYearEnrollmentWindowsMutation = graphql.persisted(
  "UpdateSchoolYearEnrollmentWindows",
  graphql(`
    mutation UpdateSchoolYearEnrollmentWindows(
      $schoolYearId: ID!
      $reenrollmentOpen: Boolean
      $openEnrollmentOpen: Boolean
    ) {
      updateSchoolYearEnrollmentWindows(
        input: {
          schoolYearId: $schoolYearId
          reenrollmentOpen: $reenrollmentOpen
          openEnrollmentOpen: $openEnrollmentOpen
        }
      ) {
        schoolYear {
          id
          reenrollmentOpen
          openEnrollmentOpen
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateSchoolYearEnrollmentWindowsMutation };

export function useUpdateSchoolYearEnrollmentWindows() {
  return useMutation(UpdateSchoolYearEnrollmentWindowsMutation);
}
